import { PageWithTitle } from "@common/components/PageLayout/PageWithTitle";
import { TopReimbursedTile } from "./tiles/ReimbursedTile";
import { SpenderDeptTile } from "./tiles/SpendersDeptTile";
import { TimeSavedTile } from "./tiles/TimeSavedTile";
import { OverviewTile } from "./tiles/OverviewTile";

export const AdminHomePage = () => {
  return (
    <PageWithTitle title="Home">
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <OverviewTile />
        <TopReimbursedTile />
        <TimeSavedTile />
        <SpenderDeptTile />
      </div>
    </PageWithTitle>
  );
};
